import createReactComponent from '../createReactComponent';
export default createReactComponent('circles', 'IconCircles', [
  ['path', { d: 'M12 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0', key: 'svg-0' }],
  ['path', { d: 'M6.5 17m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0', key: 'svg-1' }],
  ['path', { d: 'M17.5 17m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0', key: 'svg-2' }],
]);
